module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAn0lEQVRIx2NgUJhPKzRq9LAw+j/RoLOzs7+/n3j1xBp9+vRpoLlA0y9evEhlo2/dupWdnZ2UlPT48WMqGw0EOjo6Ghoaf//+pbLRXV1dDGBQVVVFTaOXLVvGzc0NMZqdnX3GjBnUMfr+/fva2touLi6GYGBjY2NhYQEMeuq4+siRI729vZWVlTU1NVOnTj127BhRrmaY6kwrNGr0cDAaACzCrsf2kWU0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ls.png
// module id = 872
// module chunks = 0